<template>
  <div>
    <div class="fullscreen-modal__content">
      <page>
        <page-title>
          {{ $t('c.contentExportOverlay.stepArticles.title') }}
        </page-title>

        <div class="topbar add-margin-bottom-full">
          <dropdown-input
            :options="selectDropdownOptions"
            theme="primary"
            position="right"
            @select="handleSelectDropdownSelect"
          >
            <button-input>
              <font-awesome-icon icon="toggle-on" />
              <font-awesome-icon icon="angle-down" />
            </button-input>
          </dropdown-input>
        </div>

        <div class="articles-list">
          <draggable
            :value="articles"
            :options="dragOptions"
            @input="articles => setArticles(articles)"
            @start="drag=true"
            @end="drag=false"
          >
            <list-item
              v-for="article in articles"
              :key="article.id"
              :title="article.title"
              :title-clickable="true"
              :sortable="true"
              :switch-name="article.id"
              :switch-value="isArticleSelected(article)"
              @switch-input="selectArticle(article)"
              @on-click="openArticle(article)"
            />
          </draggable>
        </div>
      </page>
    </div>
    <div class="fullscreen-modal__footer">
      <div class="container">
        <div class="row">
          <div class="col-xs-6 col-lg-4 push-lg-2">
            <button-input
              v-t="'c.contentExportOverlay.stepArticles.btnNext'"
              :is-disabled="stepIsInvalid"
              @click="nextStep"
            />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapState, mapGetters } from 'vuex'
import draggable from 'vuedraggable'
import PageMixin from '@/mixins/pages/Page'
import FormMixin from '@/mixins/forms/Form'
import ListItem from '@/components/ui/ListItem'
import FontAwesomeIcon from '@fortawesome/vue-fontawesome'

export default {
  name: 'ContentExpoerStepArticles',

  mixins: [PageMixin, FormMixin],

  components: {
    ListItem,
    draggable,
    FontAwesomeIcon
  },

  computed: {
    ...mapState ({
      articles: state => state.contentExport.articles,
      selected: state => state.contentExport.articlesSelected
    }),
    ...mapGetters ({
      isArticleSelected: 'contentExport/isArticleSelected',
    }),
    selectDropdownOptions () {
      return [
        { label: 'Alle auswählen', value: 'selectall', icon: 'toggle-on' },
        { label: 'Alle abwählen', value: 'deselectall', icon: 'toggle-off' }
      ]
    },
    dragOptions () {
      return {
        handle: '.list-item__handle'
      }
    },
    stepIsInvalid () {
      return this.selected.length === 0
    }
  },

  methods: {
    ...mapActions ({
      nextStep: 'contentExport/nextStep',
      selectArticle: 'contentExport/selectArticle',
      setArticles: 'contentExport/setArticles',
      selectAllArticles: 'contentExport/selectAllArticles',
    }),

    openArticle (article) {
      window.open(article.href, '_blank')
    },

    handleSelectDropdownSelect ({ value }) {
      switch (value) {
        case 'selectall':
          this.selectAllArticles(true)
          break
        case 'deselectall':
          this.selectAllArticles(false)
          break
        default:
          window.alert(`action: ${value}`)
      }
    }
  }
}
</script>

<style lang="sass" scoped>
@import '~styles/imports'

.topbar
  display: flex
  justify-content: flex-end
  align-items: center
</style>



// WEBPACK FOOTER //
// src/components/export/steps/Articles.vue